// import React from 'react'
// import blogs from '../../api/blogs'
// import {Link} from 'react-router-dom'
// import bShape1 from '../../images/blog/Vector1.png'
// import bShape2 from '../../images/blog/Vector2.png'
// import SectionTitle from '../SectionTitle'
// // Import blog images
// import maakResidence2 from '../../images/projects/maak-residence-2.jpg';
// import aizelInterior1 from '../../images/projects/aizel-interior-1.jpg';
// import aizelTowerWarsan1 from '../../images/projects/aizel-tower-warsan-1.jpg';

// const BlogSection = (props) => {
    
//     const ClickHandler = () =>{
//         window.scrollTo(10, 0);
//      }

//     return(

//         <section className="wpo-blog-section section-padding" id="blog">
//             <div className="container">
//                 <SectionTitle subTitle={'Our Blog'} MainTitle={'Our Latest News'}/>
//                 <div className="wpo-blog-items">
//                     <div className="row">
//                         {blogs.slice(0,3).map((blog, Bitem) => (
//                             <div className="col col-lg-4 col-md-6 col-12" key={Bitem}>
//                                 <div className="wpo-blog-item">
//                                     <div className="wpo-blog-img">
//                                         {blog.id === '1' && <img src={maakResidence2} alt=""/>}
//                                         {blog.id === '2' && <img src={aizelInterior1} alt=""/>}
//                                         {blog.id === '3' && <img src={aizelTowerWarsan1} alt=""/>}
//                                         <div className="thumb">{blog.thumb}</div>
//                                     </div>
//                                     <div className="wpo-blog-content">
//                                         <ul>
//                                             <li>{blog.create_at}</li>
//                                             <li>By <Link onClick={ClickHandler} to={`/blog-single/${blog.id}`}>{blog.author}</Link></li>
//                                         </ul>
//                                         <h2><Link onClick={ClickHandler} to={`/blog-single/${blog.id}`}>{blog.title}</Link></h2>
//                                         <p>{blog.description}</p>
//                                     </div>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//             <div className="vector-1">
//                 <img src={bShape1} alt=""/>
//             </div>
//             <div className="vector-2">
//                 <img src={bShape2} alt=""/>
//             </div>
//         </section>
//     )
// }

// export default BlogSection;












import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../SectionTitle';
import bShape1 from '../../images/blog/Vector1.png';
import bShape2 from '../../images/blog/Vector2.png';
import { getHomeBlogs } from '../../api/Home'; // Your API service function

const BlogSection = (props) => {
    const [homeBlogs, setHomeBlogs] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const data = await getHomeBlogs();
            setHomeBlogs(data);
        };
        fetchData();
    }, []);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    if (homeBlogs.length === 0) return null; // Avoid rendering before data

    const section = homeBlogs[0]; // Use first HomeBlog record

    return (
        <section className="wpo-blog-section section-padding" id="blog">
            <div className="container">
                <SectionTitle subTitle={section.subtitle} MainTitle={section.MainTitle} />
                <div className="wpo-blog-items">
                    <div className="row">
                        {section.cards.slice(0, 3).map((card, index) => (
                            <div className="col col-lg-4 col-md-6 col-12" key={index}>
                                <div className="wpo-blog-item">
                                    <div className="wpo-blog-img">
                                        <img src={card.cardimage} alt={card.button2} />
                                    </div>
                                    <div className="wpo-blog-content">
                                        <ul>
                                            <li>
  {(() => {
    const d = new Date(card.date);
    const day = d.getDate();
    const month = d.toLocaleString('en-US', { month: 'short' }).toUpperCase();
    const year = d.getFullYear().toString().slice(-2);
    return `${day} ${month},${year}`;
  })()}
</li>
                                             <li>
                                                By{' '}
                                                <Link onClick={ClickHandler} to={card.button1_link}>
                                                    {card.button1}
                                                </Link>
                                            </li>
                                        </ul>
                                        <h2>
                                            <Link onClick={ClickHandler} to={card.button2_link}>
                                                {card.button2}
                                            </Link>
                                        </h2>
                                        <p>{card.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="vector-1">
                <img src={bShape1} alt="" />
            </div>
            <div className="vector-2">
                <img src={bShape2} alt="" />
            </div>
        </section>
    );
};

export default BlogSection;
